const KnygynasSkeletonLoader = () => (
  <div className="relative pt-20">
    <section className="relative z-10 min-h-[calc(100vh-5rem)] flex flex-col justify-center py-12 gap-10">
      <div className="px-8 mb-2">
        <div className="h-10 w-48 rounded-lg bg-muted animate-pulse" />
      </div>
      {[0, 1].map((row) => (
        <div key={row}>
          <div className="flex items-center gap-3 px-8 mb-3">
            <div className="h-3 w-24 rounded bg-muted animate-pulse" />
            <div className="flex-1 h-px bg-foreground/10" />
          </div>
          <div className="flex gap-4 overflow-hidden px-6 py-4">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="flex-shrink-0 w-44 md:w-48">
                <div className="aspect-[2/3] rounded-2xl bg-muted animate-pulse" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  </div>
);

export default KnygynasSkeletonLoader;
